import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { Button, Link } from 'components/common';
import { Icon } from 'components/common/icons';

type Props =
  | {
      as?: string;
      href?: string;
      text?: string;
      onBackClick?: () => void;
      simpleReturn: true;
    }
  | {
      as: string;
      href: string;
      text: string;
      onBackClick?: never;
      simpleReturn?: false;
    };

const BoxBackLink = ({ as, href, text, onBackClick, simpleReturn }: Props) => {
  const { messages, theme } = useReduxState();

  const router = useRouter();

  return simpleReturn ? (
    <div className="back-button">
      <Button
        category="transparent"
        icon="arrow-left"
        onClick={onBackClick ?? (() => router.back())}
        style={{
          color: theme.textColorLight,
          fontSize: '1.5rem',
          fontWeight: 600,
          padding: 0
        }}
        text={text || messages.commonGoBack}
      />

      <style jsx>{`
        .back-button :global(> button:hover) {
          background-color: transparent;
          text-decoration: underline;
        }
      `}</style>
    </div>
  ) : (
    <Link
      as={as}
      href={href}
      style={{ color: theme.textColorLight, fontSize: '1.5rem' }}
      text={
        <>
          <Icon
            icon="arrow-left"
            style={{
              fontSize: '1.2rem',
              marginRight: 6,
              position: 'relative',
              top: -1
            }}
          />
          {text}
        </>
      }
    />
  );
};

export default BoxBackLink;
